// Get references to the buttons and the 'kohdehaku' div
var openSearchBtns = document.querySelectorAll('.opensearch');
var closeSearchBtns = document.querySelectorAll('.closesearch');
var kohdehakuDiv = document.querySelector('.kohdehaku');


if (kohdehakuDiv) {

    // Function to show the 'kohdehaku' div
    function showKohdehaku() {
        kohdehakuDiv.style.display = 'block';
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        if (windowWidth < 1120) {
            document.documentElement.classList.add('is-active-popup');
        }
    }

    // Function to hide the 'kohdehaku' div
    function hideKohdehaku() {
        kohdehakuDiv.style.display = 'none';
        document.documentElement.classList.remove('is-active-popup');
    }

    // Function to toggle visibility of 'kohdehaku' based on window width
    function toggleKohdehakuVisibility() {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        if (windowWidth < 1120) {
            hideKohdehaku();
        } else {
            showKohdehaku();
        }
    }

    // Call the toggle function initially
    toggleKohdehakuVisibility();


/*     // Handle window resize event
    window.addEventListener('resize', toggleKohdehakuVisibility); */
    // Handle window resize event //ONLY WIDTH
    var lastWidth = window.innerWidth || document.documentElement.clientWidth;
    window.addEventListener('resize', function() {
        var currentWidth = window.innerWidth || document.documentElement.clientWidth;
        if (currentWidth !== lastWidth) {
            // Width has changed, perform your action here
            toggleKohdehakuVisibility();
            lastWidth = currentWidth; // Update lastWidth variable
        }
    });

    // Add click event listener to all 'opensearch' buttons
    openSearchBtns.forEach(function(button) {
        button.addEventListener('click', function() {
            showKohdehaku();
        });
    });

    // Add click event listener to all 'closesearch' buttons
    closeSearchBtns.forEach(function(button) {
        button.addEventListener('click', function() {
            hideKohdehaku();
        });
    });

}
